﻿<div class="error-container">
    <h1>{{statusCode}}</h1>
    <p class="error-reason">{{errorHeader}}</p>
	<p class="options" *ngIf="isUserLoggedIn()">
		{{errorDescriptionToDisplay}}<a [routerLink]="['/', rolePath, 'home']">{{linkToText}}</a>{{errorDescriptionToDisplay2}}
	</p>
	<p class="options" *ngIf="!isUserLoggedIn()">
		{{errorDescriptionToDisplay}}<a [routerLink]="['/login']">{{linkToText}}</a>{{errorDescriptionToDisplay2}}
	</p>
</div>